// If you are adding a term to the ActionSubject glossary,
// please add a member of the Data team to your PR

export const ActionSubject = {
  accountEmail: 'accountEmail',
  atlassianSwitcherHeaderButton: 'atlassianSwitcherHeaderButton',
  avatar: 'avatar',
  banner: 'banner',
  board: 'board',
  boardBackground: 'boardBackground',
  boardPref: 'boardPref',
  boardVisibility: 'boardVisibility',
  button: 'button',
  card: 'card',
  checkbox: 'checkbox',
  comment: 'comment',
  commentsPermissions: 'commentsPermissions',
  drawer: 'drawer',
  drawerNavigationItem: 'drawerNavigationItem',
  dropdown: 'dropdown',
  dropdownItem: 'dropdownItem',
  editor: 'editor',
  embed: 'embed',
  error: 'error',
  feature: 'feature',
  icon: 'icon',
  inlineDialog: 'inlineDialog',
  input: 'input',
  invitation: 'invitation',
  invitationsPermissions: 'invitationsPermissions',
  keyboardShortcut: 'keyboardShortcut',
  link: 'link',
  location: 'location',
  mention: 'mention',
  menu: 'menu',
  notification: 'notification',
  onboarding: 'onboarding',
  organization: 'organization',
  overlay: 'overlay',
  panel: 'panel',
  pill: 'pill',
  powerUp: 'powerUp',
  prompt: 'prompt',
  primaryEmail: 'primaryEmail',
  radioButton: 'radioButton',
  reactionPicker: 'reactionPicker',
  search: 'search',
  secondaryEmail: 'secondaryEmail',
  select: 'select',
  sticker: 'sticker',
  shortcut: 'shortcut',
  tab: 'tab',
  textField: 'textField',
  tile: 'tile',
  toggle: 'toggle',
  tooltip: 'tooltip',
  ui: 'ui', // this should only be used for stock "UI viewed"-type events
  upload: 'upload',
} as const;

export type ActionSubjectType = typeof ActionSubject[keyof typeof ActionSubject];

export const isValidActionSubject = (a: ActionSubjectType) => {
  const validSources = Object.values(ActionSubject);
  return validSources.includes(a);
};
